import { render, staticRenderFns } from "./bimTextH3.vue?vue&type=template&id=10e92476&scoped=true&lang=html&"
import script from "./bimTextH3.vue?vue&type=script&lang=js&"
export * from "./bimTextH3.vue?vue&type=script&lang=js&"
import style0 from "./bimTextH3.vue?vue&type=style&index=0&id=10e92476&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e92476",
  null
  
)

export default component.exports